import { render, staticRenderFns } from "./ReqTrasladoLocTableComponent.vue?vue&type=template&id=b8773c4c&"
import script from "./ReqTrasladoLocTableComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoLocTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports